import React from "react";
import SectionHeading from "../ui/SectionHeading";
import TeamMemberCard from "../ui/TeamMemberCard";

const teamMembers = [
  {
    name: "Masum Miah",
    position: "Income Tax Lawyer & VAT Consultant",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgcEHR4vjjckCfBpSXWgSYqz5dFnYsW3101xNaxcCDXaCwEP5hxNA6DN1WWAdy7Bux3CoPoAyk_pgmLtF-qqeyXxn5kkwXAisUSBoXJIDwcugoQbRmd8Bv7gR7AO0eIE6h1C8ELLWIvugNfCqZXMGN_e8fXT4pEcxgVjNMq4jm56x7XcY6pMoNq4aII1wQ/w567-h757/masum-vai.jpg",
    email: "miahmasum04@gmail.com",
    phone: "+8801710908697",
    linkedin: "https://linkedin.com/",
    bio: "With over 15 years of experience in tax law and consultancy, Masum leads our team with expertise in complex tax matters and business advisory services.",
  },
  {
    name: "Nusrat Jahan",
    position: "Senior Accountant",
    image:
      "https://images.pexels.com/photos/7959077/pexels-photo-7959077.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    email: "accounting@psabd.com",
    phone: "+8801812345678",
    linkedin: "https://linkedin.com/",
    bio: "Nusrat specializes in financial reporting, audit preparation, and management accounting with a focus on helping businesses improve their financial processes.",
  },
  {
    name: "Kamrul Hasan",
    position: "VAT Specialist",
    image:
      "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    email: "vat@psabd.com",
    phone: "+8801912345678",
    linkedin: "https://linkedin.com/",
    bio: "Kamrul brings extensive expertise in VAT regulations and compliance, helping clients navigate complex VAT requirements and optimize their VAT positions.",
  },
];

const TeamList = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <SectionHeading
          title="Meet Our Team"
          subtitle="Our experienced professionals are dedicated to providing exceptional service and expertise."
          center
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-16">
          {teamMembers.map((member, index) => (
            <TeamMemberCard
              key={index}
              name={member.name}
              position={member.position}
              image={member.image}
              email={member.email}
              phone={member.phone}
              linkedin={member.linkedin}
              bio={member.bio}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamList;
